import { Component, Table } from "@mcleod/components";
import { ArrayUtil } from "@mcleod/core";

export class ActionSwitchAdjacentComponents {
  component: Component;
  by: number;

  constructor(component, by) {
    this.component = component;
    this.by = by;
  }

  execute() {
    this.switchComps(this.by);
  }

  switchComps(by) {
    const parent = this.component.parent;
    if (parent instanceof Table)
      parent._handleSpecialSwitch(this.component, by)
    else if (parent.indexOf != null) {
      const index = parent.indexOf(this.component);
      const switchIndex = index + by;
      if (switchIndex >= 0 && switchIndex < parent.components.length) {
        ArrayUtil.switchArrayElements(parent.components, index, switchIndex);
        parent.reLayout();
      }
    }
  }

  undo() {
    this.switchComps(this.by * -1);
  }

  toString() {
    return "Switch " + this.component.constructor.name;
  }
}
